import * as yup from 'yup';

import { useCampInputStore } from '@/features/Sparten/camp/useInputStore';
import {
  hasJaehrlicheFahrleistung,
  hasLeistung,
  hasNeuwert,
  hasNutzungsart,
  hasAnhaengerBauart,
} from '@/features/Sparten/shared/renderConditions/kfz/sharedRenderConditions';

export const validateZulassungsdatumAufVN = (value: Date | null): boolean => {
  const store = useCampInputStore();

  if (value == null || store.fahrzeug.erstbesitzer) {
    return true;
  }

  const zulassung = store.fahrzeug.erstzulassung;

  return !(zulassung !== null && value < zulassung);
};

export const minimumErstzulassungsdatum = new Date('1900-01-01');
export const validateErstzulassungsdatum = (value: Date | null): boolean =>
  value === null || value >= minimumErstzulassungsdatum;

export const fahrzeugSchema = yup.object({
  aufbauart: yup.string().default(''),
  dachart: yup.string().default(''),
  anhaengerVerleihung: yup
    .boolean()
    .default(false)
    .when({
      is: () => hasAnhaengerBauart.value,
      then: yup.boolean().required(),
    }),
  gesellschaftZugfahrzeug: yup
    .number()
    .default(0)
    .when({
      is: () => hasAnhaengerBauart.value,
      then: yup.number().required(),
    }),
  gesamtgewicht: yup.number().default(0).min(1).max(100000).required(),
  leistung: yup
    .number()
    .default(0)
    .when({
      is: () => hasLeistung.value,
      then: yup
        .number()
        .min(1, 'Die Leistung in kW muss mindestens 1 betragen')
        .required(),
    }),
  neuwert: yup
    .number()
    .default(0)
    .when({
      is: () => hasNeuwert.value,
      then: yup.number().min(1).max(300000).required(),
    }),
  zeitwert: yup.number().default(0).min(1).max(300000).required(),
  fahrleistung: yup
    .number()
    .default(0)
    .when({
      is: () => hasJaehrlicheFahrleistung.value,
      then: yup.number().min(100).required(),
    }),
  kilometerstand: yup.number().default(null).nullable(),
  finanzierungsart: yup.string().default(''),
  auslandsnutzung: yup.string().default(''),
  nutzungsart: yup
    .string()
    .default('')
    .when({
      is: () => hasNutzungsart.value,
      then: yup.string().required(),
    }),
  erstzulassung: yup
    .date()
    .nullable()
    .default(null)
    .required()
    .test(
      'validErstzulassungsDatum',
      'Darf nicht vor 01.01.1900 liegen',
      validateErstzulassungsdatum,
    ),
  erstbesitzer: yup.boolean().default(false),
  erstmaligeZulassungAufVN: yup
    .date()
    .nullable()
    .default(null)
    .test(
      'validZulassungsDatum',
      'Darf nicht vor Erstzulassung liegen.',
      validateZulassungsdatumAufVN,
    )
    .when('erstbesitzer', {
      is: (val: boolean) => !val,
      then: yup.date().required(),
    }),
});
